import React from 'react';
import { SupportRequestModalForm } from '../../components/support-request-modal-form';
import { ControlledInputField } from 'components/controlled-input-field';
import { ControlledTextArea } from 'features/my-zone/support-requests/components/support-requests-modals/components/inputs/controlled-textarea';
import { ControlledFileUpload } from 'features/my-zone/support-requests/components/support-requests-modals/components/inputs/controlled-file-upload';
import { supportedFileTypes } from 'features/my-zone/support-requests/components/support-requests-modals/consts/consts';
import { SupportEmailInput } from 'features/my-zone/support-requests/components/support-requests-modals/components/inputs/controlled-support-email-input/support-email-input';
import { FileWithUrl, FlexContainer } from '@placer-ui/components';
import { getFeatureFlags } from 'core/flow-control';
import {
    SupportOpportunityUrlInput,
    SupportSalesEmailInput,
} from 'features/my-zone/support-requests/components/support-requests-modals/components/inputs/controlled-support-sales-email-inputs/support-sales-email-inputs';

import styles from './support-requests-ask-support.module.scss';

const MODAL_TITLE = 'Ask Support a Question';
const MODAL_SUBTITLE =
    'Found something that we can fix? Couldn’t find an answer in our Help Center? We’re happy to help!';

export interface SupportRequestsAskSupportFormValues {
    type: 'question';
    subject: string;
    additionalInformation: string;
    files: FileWithUrl[];
    executiveEmail?: string;
    opportunityUrl?: string;
}

export const convertAskSupportFormToRequestPayload = (
    values: SupportRequestsAskSupportFormValues,
) => ({
    ...values,
    files: values.files.map(({ file }) => file),
});

export const SupportRequestsAskSupportModal = () => {
    const { enable_request_properties_sales_flow_ff } = getFeatureFlags();

    return (
        <SupportRequestModalForm<SupportRequestsAskSupportFormValues>
            title={MODAL_TITLE}
            subTitle={MODAL_SUBTITLE}
            withBackButton={false}
            requestType="askSupport"
            defaultValues={{ type: 'question', files: [] }}
            convertToRequestPayload={convertAskSupportFormToRequestPayload}
        >
            <div className={styles.askSupportContent}>
                {enable_request_properties_sales_flow_ff && (
                    <FlexContainer gap={16}>
                        <SupportSalesEmailInput />
                        <SupportOpportunityUrlInput />
                    </FlexContainer>
                )}
                {!enable_request_properties_sales_flow_ff && <SupportEmailInput />}
                <ControlledInputField
                    name="subject"
                    label="Subject"
                    placeholder="Provide a clear subject for your request"
                    maxLength={100}
                    required
                    asterix
                    testId="support-requests-ask-support-subject"
                />
                <ControlledTextArea
                    name="additionalInformation"
                    label="Additional Information"
                    placeholder="Share additional details to help our support team assist you better (optional)."
                    initialHeight={104}
                    maxLength={1000}
                    testId="support-requests-ask-support-details"
                />
                <ControlledFileUpload
                    name="files"
                    formats={supportedFileTypes}
                    label="Attachments"
                    feedback={[]}
                    testId="support-requests-ask-support-file-upload"
                />
            </div>
        </SupportRequestModalForm>
    );
};
